import { render, staticRenderFns } from "./senaraiPADlmTindakan.vue?vue&type=template&id=9d17eeb2&scoped=true&"
import script from "./senaraiPADlmTindakan.vue?vue&type=script&lang=js&"
export * from "./senaraiPADlmTindakan.vue?vue&type=script&lang=js&"
import style0 from "./senaraiPADlmTindakan.vue?vue&type=style&index=0&id=9d17eeb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d17eeb2",
  null
  
)

export default component.exports